// extracted by mini-css-extract-plugin
export var tabIcon = "styles-module__tabIcon___Np1fw";
export var tab = "styles-module__tab___feUCL";
export var active = "styles-module__active___EuL5p";
export var tabBar = "styles-module__tabBar___ytpd8";